import { ApolloError, NetworkStatus } from "@apollo/client";
import Spinner from "../../components/spinner/Spinner";
import { PersonDto } from "../../interfaces/schema";

const usePersonChecks = (
  loading: boolean,
  error: ApolloError | undefined,
  data: { person: PersonDto } | undefined,
  /**
   * Apollos networkStatus fra samme forespørgsel som `loading`. Udelades den, vises spinneren
   * ved enhver loading som før — kaldere skal ikke ændres for at beholde den gamle adfærd.
   */
  networkStatus?: NetworkStatus,
) => {
  if (error) {
    const isOnlyAuthError = error.graphQLErrors.every(
      (graphQLError) => graphQLError.extensions?.code === "AUTH_NOT_AUTHORIZED",
    );

    if (!isOnlyAuthError) {
      console.error(error);
      return { checkResult: <div>Noget gik galt 😔</div>, person: null };
    }
  }

  /**
   * Et refetch må ikke tømme skærmen.
   *
   * Personens faner giver deres refetch videre til hver sektion som invalidateData, så en
   * redigering af ét felt udløser et refetch af hele fanen. Forespørgslerne kører med
   * notifyOnNetworkStatusChange, så det sætter loading — og uden denne undtagelse erstattes
   * fanen af en spinner og monteres igen ved hver redigering. De data, der allerede står på
   * skærmen, er stadig gyldige, mens de nye hentes.
   *
   * Bevidst kun refetch og ikke enhver loading med data: skifter man til en anden person, er
   * det NetworkStatus.setVariables, og `data` hører stadig til den FORRIGE person. Dem må vi
   * ikke vise under den nye persons overskrift — der er spinneren det rigtige svar.
   */
  const genhenterMedDataPaaSkaermen =
    networkStatus === NetworkStatus.refetch && Boolean(data);

  if (loading && !genhenterMedDataPaaSkaermen) {
    return { checkResult: <Spinner />, person: null };
  }
  if (!data) {
    return { checkResult: <div>Ingen data fundet 😯</div>, person: null };
  }
  if (!data.person) {
    return { checkResult: <div>Fandt ikke person 😯</div> };
  }

  return { checkResult: null, person: data.person };
};

export default usePersonChecks;
